import { useEffect, useState } from 'react';

export type Route =
  | { name: 'chat' }
  | { name: 'share'; id: string };

function parseRoute(pathname: string): Route {
  if (pathname.startsWith('/s/')) {
    const id = pathname.replace('/s/', '').split('/')[0];
    if (id) {
      return { name: 'share', id };
    }
  }

  return { name: 'chat' };
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() =>
    parseRoute(window.location.pathname)
  );

  useEffect(() => {
    const handler = () => setRoute(parseRoute(window.location.pathname));
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);

  return route;
}

export function navigateTo(path: string) {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export const goHome = () => navigateTo('/');
